var _circle, _circle2, _path, _circle3, _circle4, _rect, _circle5, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExperiencedTechnician(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#8B5CF6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#3B82F6",
      stopOpacity: 1
    }
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 70,
    r: 30,
    fill: "url(#grad1)",
    opacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 70,
    r: 25,
    fill: "url(#grad1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 90 75 Q 90 85 100 85 Q 110 85 110 75",
    stroke: "white",
    strokeWidth: 2,
    fill: "none"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 65,
    r: 2,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 65,
    r: 2,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 120,
    width: 8,
    height: 40,
    rx: 2,
    fill: "url(#grad1)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 115,
    r: 6,
    fill: "url(#grad1)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(130, 135)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 20,
    fill: "url(#grad1)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3,
    y: -25,
    width: 6,
    height: 10,
    fill: "url(#grad1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3,
    y: 15,
    width: 6,
    height: 10,
    fill: "url(#grad1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: -3,
    width: 10,
    height: 6,
    fill: "url(#grad1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: -3,
    width: 10,
    height: 6,
    fill: "url(#grad1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperiencedTechnician);
export default __webpack_public_path__ + "static/media/ExperiencedTechnician.36311bc8b4089e01161e2eed8bc7bbbb.svg";
export { ForwardRef as ReactComponent };